/* eslint-disable spellcheck/spell-checker */
const template = {
  page: {
    title: '',
    description: '',
    template: {
      name: 'template-base',
      type: 'basic',
      version: '0.0.1',
    },
    body: {
      type: 'mailup-bee-page-proprerties',
      container: {
        style: {
          'background-color': '#FFFFFF',
        },
      },
      content: {
        style: {
          'font-family': "Arial, 'Helvetica Neue', Helvetica, sans-serif",
          color: '#000000',
        },
        computedStyle: {
          linkColor: '#0000FF',
          messageBackgroundColor: 'transparent',
          messageWidth: '500px',
        },
      },
      webFonts: [],
    },
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {},
                type: 'mailup-bee-newsletter-modules-empty',
                uuid: '09c4b7df-3102-4b8c-9d1a-2a9778d0b9c1',
              },
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '5px',
            },
            uuid: '19c4f876-d466-4c49-882e-ac5920fc68c4',
          },
        ],
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
          },
        },
        content: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#000000',
            width: '500px',
          },
        },
        type: 'one-column-empty',
        uuid: '475f3b53-b9e6-4785-8476-531623a3da12',
      },
      {
        name: 'One Column (Empty)',
        type: 'one-column-empty',
        container: {
          style: {
            'background-color': 'transparent',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
          },
        },
        content: {
          style: {
            'background-color': 'transparent',
            color: '#000000',
            width: '500px',
            'background-image': 'none',
            'background-repeat': 'no-repeat',
            'background-position': 'top left',
          },
          computedStyle: {
            rowColStackOnMobile: true,
          },
        },
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                type: 'mailup-bee-newsletter-modules-text',
                descriptor: {
                  text: {
                    html: '<div class="txtTinyMce-wrapper" style="font-size: 12px; line-height: 14px;" data-mce-style="font-size: 12px; line-height: 14px;"><div style="font-size: 14px; line-height: 16px; text-align:center;" data-mce-style="font-size: 14px; line-height: 16px; text-align:center;">{% unsubscribe %}</div></div>',
                    style: {
                      color: '#555555',
                      'line-height': '120%',
                      'font-family': 'inherit',
                    },
                    computedStyle: {
                      linkColor: '#0000FF',
                    },
                  },
                  style: {
                    'padding-top': '10px',
                    'padding-right': '10px',
                    'padding-bottom': '10px',
                    'padding-left': '10px',
                  },
                  computedStyle: {
                    hideContentOnMobile: false,
                  },
                },
              },
            ],
            style: {
              'background-color': 'transparent',
              'padding-top': '5px',
              'padding-right': '0px',
              'padding-bottom': '5px',
              'padding-left': '0px',
              'border-top': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
            },
          },
        ],
      },
    ],
  },
};

export default template;
